
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as notifiche_45clientipxX5CpZveARuS11Nb8zmSfNKdo4oMitmLD4frkFDF84Meta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/notifiche-clienti.vue?macro=true";
import { default as codice_authenticator0nIy5oi1qRHaH7nbvd8iy4GZnUGfpMk5I86mhBtaAuMMeta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/verifica_dispositivo/codice_authenticator.vue?macro=true";
import { default as codice_email9w188TZD9SDjPcf9dGDXMQ0iFMNSABpCnLQfil3wXt8Meta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/verifica_dispositivo/codice_email.vue?macro=true";
import { default as assistenzaar0tMMMC3BFJyK566z0vjQM2meizSok6OEkKJDsPUyIMeta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/assistenza.vue?macro=true";
import { default as impostazioniTaf4U8RFvL19IGQGJKkMC9eL5mZcrwXjexCe53ikNGkMeta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/impostazioni.vue?macro=true";
import { default as logins4SX791I__vLUE_wCxgkrAY6BMR5QDPtnDx8Bof5OEUMeta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/login.vue?macro=true";
import { default as notifichehB1ULV3BdaM0p_J59T2gbjngaYdaPP77OkJCIeoBSv0Meta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/notifiche.vue?macro=true";
import { default as privacyoDlkqY89Q_aUIngbrBMRtC2XsPU7diFfccbckPFu6_gMeta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/privacy.vue?macro=true";
import { default as profilozyiQTyFgNBFC7xAN6UCItR_VasnsZrn1D_jhx7xf8cAMeta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/profilo.vue?macro=true";
import { default as recupera_45passwordt4cl165PRvILGMjroR_EcPal01UvqxyUK5E_hhb_xIEMeta } from "/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/recupera-password.vue?macro=true";
export default [
  {
    name: "anagrafiche-allarmi",
    path: "/anagrafiche/allarmi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/anagrafiche/allarmi.vue")
  },
  {
    name: "anagrafiche-dispositivi",
    path: "/anagrafiche/dispositivi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/anagrafiche/dispositivi.vue")
  },
  {
    name: "anagrafiche-firmware",
    path: "/anagrafiche/firmware",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/anagrafiche/firmware.vue")
  },
  {
    name: "anagrafiche-impianti",
    path: "/anagrafiche/impianti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/anagrafiche/impianti.vue")
  },
  {
    name: "anagrafiche-modelli_inverters",
    path: "/anagrafiche/modelli_inverters",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/anagrafiche/modelli_inverters.vue")
  },
  {
    name: "anagrafiche-utenti",
    path: "/anagrafiche/utenti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/anagrafiche/utenti.vue")
  },
  {
    name: "anagrafiche-utenti_api",
    path: "/anagrafiche/utenti_api",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/anagrafiche/utenti_api.vue")
  },
  {
    name: "monitoraggio-firmware",
    path: "/monitoraggio/firmware",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/monitoraggio/firmware.vue")
  },
  {
    name: "monitoraggio-impianti",
    path: "/monitoraggio/impianti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/monitoraggio/impianti.vue")
  },
  {
    name: "storico-allarmi",
    path: "/storico/allarmi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/storico/allarmi.vue")
  },
  {
    name: "storico-batteria",
    path: "/storico/batteria",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/storico/batteria.vue")
  },
  {
    name: "storico-comandi",
    path: "/storico/comandi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/storico/comandi.vue")
  },
  {
    name: "storico-inclinazioni",
    path: "/storico/inclinazioni",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/storico/inclinazioni.vue")
  },
  {
    name: "storico-meteo",
    path: "/storico/meteo",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/storico/meteo.vue")
  },
  {
    name: "storico-produzione",
    path: "/storico/produzione",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/storico/produzione.vue")
  },
  {
    name: "strumenti-archivio",
    path: "/strumenti/archivio",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/archivio.vue")
  },
  {
    name: "strumenti-backup",
    path: "/strumenti/backup",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/backup.vue")
  },
  {
    name: "strumenti-database",
    path: "/strumenti/database",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/database.vue")
  },
  {
    name: "strumenti-log_api",
    path: "/strumenti/log_api",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/log_api.vue")
  },
  {
    name: "strumenti-log_attivita",
    path: "/strumenti/log_attivita",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/log_attivita.vue")
  },
  {
    name: "strumenti-log_comandi",
    path: "/strumenti/log_comandi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/log_comandi.vue")
  },
  {
    name: "strumenti-log_eventi",
    path: "/strumenti/log_eventi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/log_eventi.vue")
  },
  {
    name: "strumenti-notifiche-clienti",
    path: "/strumenti/notifiche-clienti",
    meta: { ...(notifiche_45clientipxX5CpZveARuS11Nb8zmSfNKdo4oMitmLD4frkFDF84Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/strumenti/notifiche-clienti.vue")
  },
  {
    name: "verifica_dispositivo-codice_authenticator",
    path: "/verifica_dispositivo/codice_authenticator",
    meta: codice_authenticator0nIy5oi1qRHaH7nbvd8iy4GZnUGfpMk5I86mhBtaAuMMeta || {},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/verifica_dispositivo/codice_authenticator.vue")
  },
  {
    name: "verifica_dispositivo-codice_email",
    path: "/verifica_dispositivo/codice_email",
    meta: codice_email9w188TZD9SDjPcf9dGDXMQ0iFMNSABpCnLQfil3wXt8Meta || {},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/verifica_dispositivo/codice_email.vue")
  },
  {
    name: "impianti-id",
    path: "/impianti/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/impianti/[id].vue")
  },
  {
    name: "assistenza",
    path: "/assistenza",
    meta: { ...(assistenzaar0tMMMC3BFJyK566z0vjQM2meizSok6OEkKJDsPUyIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/assistenza.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/dashboard.vue")
  },
  {
    name: "impostazioni",
    path: "/impostazioni",
    meta: { ...(impostazioniTaf4U8RFvL19IGQGJKkMC9eL5mZcrwXjexCe53ikNGkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/impostazioni.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(logins4SX791I__vLUE_wCxgkrAY6BMR5QDPtnDx8Bof5OEUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/login.vue")
  },
  {
    name: "notifiche",
    path: "/notifiche",
    meta: { ...(notifichehB1ULV3BdaM0p_J59T2gbjngaYdaPP77OkJCIeoBSv0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/notifiche.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyoDlkqY89Q_aUIngbrBMRtC2XsPU7diFfccbckPFu6_gMeta || {},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/privacy.vue")
  },
  {
    name: "profilo",
    path: "/profilo",
    meta: profilozyiQTyFgNBFC7xAN6UCItR_VasnsZrn1D_jhx7xf8cAMeta || {},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/profilo.vue")
  },
  {
    name: "recupera-password",
    path: "/recupera-password",
    meta: recupera_45passwordt4cl165PRvILGMjroR_EcPal01UvqxyUK5E_hhb_xIEMeta || {},
    component: () => import("/opt/suncore/build/20261104T151752Z-16e87b2b/app/pages/recupera-password.vue")
  }
]